import { ReactElement } from 'react';
import { Table, TableProps } from '@ohpen/enso-ui';

import { ActionEntityType } from '@pmp/api';
import { AdviserRow } from '../brokerCRConfig';

type AdvisersCRProps = { tableProps: TableProps<ActionEntityType, AdviserRow> };

export const AdvisersCR = ({ tableProps }: AdvisersCRProps): ReactElement => {
  return <Table {...tableProps} />;
};
